var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplyComment1010 = function SvgReplyComment1010(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BBBC",
    fillRule: "evenodd",
    d: "M1.442.833c.336 0 .608.286.608.64v6.414h6.509c.336 0 .608.286.608.64s-.272.64-.608.64H1.442c-.336 0-.609-.286-.609-.64V1.473c0-.354.273-.64.609-.64",
    clipRule: "evenodd"
  })));
};
export default SvgReplyComment1010;